// src/directives/permission.js
import { usePermissionsStore } from '@/store/permissions'

export const vPermission = {
  mounted(el, binding) {
    checkPermission(el, binding)
  },
  updated(el, binding) {
    checkPermission(el, binding)
  }
}

function checkPermission(el, binding) {
  const permissionsStore = usePermissionsStore()
  
  // directive 값이 문자열인 경우: v-permission="'BANNER_READ'" 또는 v-permission="'ADMIN_READ'"
  if (typeof binding.value === 'string') {
    const permissionCode = binding.value
    
    // 먼저 직접 권한 코드로 확인
    let hasPermission = permissionsStore.userPermissions?.permissions.includes(permissionCode)
    
    // 직접 권한이 없다면 메뉴 권한으로 확인 시도
    if (!hasPermission && permissionCode.includes('_')) {
      const [menuCode, action] = permissionCode.split('_')
      hasPermission = permissionsStore.hasMenuPermission(menuCode, action)
    }
    
    if (!hasPermission) {
      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        el.disabled = true
        el.style.opacity = '0.5'
        el.style.cursor = 'not-allowed'
        el.title = '권한이 없습니다'
      } else {
        el.style.display = 'none'
      }
    } else {
      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        el.disabled = false
        el.style.opacity = ''
        el.style.cursor = ''
        el.title = ''
      } else {
        el.style.display = ''
      }
    }
    return
  }
  
  // directive 값이 객체인 경우: v-permission="{ menuCode: 'BANNER', action: 'READ' }"
  if (typeof binding.value === 'object') {
    const { menuCode, action = 'READ' } = binding.value
    const hasPermission = permissionsStore.hasMenuPermission(menuCode, action)
    
    if (!hasPermission) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
    return
  }
  
  // modifier 사용: v-permission.banner.read
  if (binding.modifiers) {
    const modifierKeys = Object.keys(binding.modifiers)
    if (modifierKeys.length >= 1) {
      const menuCode = modifierKeys[0].toUpperCase()
      const action = modifierKeys[1] ? modifierKeys[1].toUpperCase() : 'READ'
      
      const hasPermission = permissionsStore.hasMenuPermission(menuCode, action)
      if (!hasPermission) {
        el.style.display = 'none'
      } else {
        el.style.display = ''
      }
    }
  }
}

/*
사용법:

1. 권한 코드로 직접 체크:
<button v-permission="'BANNER_READ'">배너 조회</button>

2. 객체로 메뉴코드와 액션 지정:
<button v-permission="{ menuCode: 'BANNER', action: 'WRITE' }">배너 수정</button>

3. modifier 사용:
<button v-permission.banner.read>배너 조회</button>
<button v-permission.banner.write>배너 수정</button>
<button v-permission.banner.delete>배너 삭제</button>
*/